import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { toFullName } from '@repo/toolkit/to-full-name'
import Checkbox from '@repo/ui/checkbox'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { Enrollment } from '../../../../lib/types/models/enrollment/enrollment'
import { EnrollmentChildInput } from '../../../../lib/types/models/enrollment/enrollment-child-input'
import { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import GeneralPhilosophyInstructions from '../child-profile-view/child-philosophy-instructions'

type Props = {
  enrollment: Pick<Enrollment, 'childFirstName' | 'childLastName'>
}

const ClientEnrolmentGeneralPhilosophy = ({ enrollment }: Props) => {
  const form = useFormContext<EnrollmentChildInput>()

  return (
    <InnerBox className="rounded-lg p-4 flex flex-col gap-4 mobile:p-3">
      <GeneralPhilosophyInstructions />
      <div className="grid grid-cols-2 gap-3 mobile:grid-cols-1">
        <InnerBox className="rounded-lg p-4 flex flex-col gap-3 ">
          <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
            Nous, parents, nous engageons à assumer la responsabilité financière si notre
            fils/fille doit être rapatrié(e) avant la fin du séjour pour mauvaise conduite. Nous
            avons pris connaissance et acceptons le contenu du guide LEC et de ce dossier
            complémentaire, et certifions n’avoir omis aucune information importante.
          </Typography>
          <FormField
            control={form.control}
            name={'parentAcceptGeneralPhilosophy'}
            render={({ field, formState: { errors } }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <Checkbox
                    {...field}
                    checked={field.value === true}
                    hasContainer
                    hasError={!!errors.parentAcceptGeneralPhilosophy}
                    onChange={(checked) =>
                      form.setValue('parentAcceptGeneralPhilosophy', checked ? true : null, {
                        shouldValidate: true
                      })
                    }
                    component={
                      <Typography
                        variant="secondary-body"
                        color={
                          errors.parentAcceptGeneralPhilosophy
                            ? tailwindColors.secondaryRed.DEFAULT
                            : tailwindColors.primary.DEFAULT
                        }
                      >
                        Je le confirme (parent, tuteur)
                      </Typography>
                    }
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </InnerBox>
        <InnerBox className="rounded-lg p-4 flex flex-col gap-3 ">
          <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
            Moi, {toFullName(enrollment.childFirstName, enrollment.childLastName)}, m'engage à
            respecter le code de bonne conduite ci-dessus.
          </Typography>
          <FormField
            control={form.control}
            name={'childAcceptGeneralPhilosophy'}
            render={({ field, formState: { errors } }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <div>
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      hasContainer
                      hasError={!!errors.childAcceptGeneralPhilosophy}
                      onChange={(checked) =>
                        form.setValue('childAcceptGeneralPhilosophy', checked ? true : null, {
                          shouldValidate: true
                        })
                      }
                      component={
                        <Typography
                          variant="secondary-body"
                          color={
                            errors.childAcceptGeneralPhilosophy
                              ? tailwindColors.secondaryRed.DEFAULT
                              : tailwindColors.primary.DEFAULT
                          }
                        >
                          Je le confirme (participant)
                        </Typography>
                      }
                    />
                  </div>
                </FormControl>
              </FormItem>
            )}
          />
        </InnerBox>
      </div>
    </InnerBox>
  )
}

export default ClientEnrolmentGeneralPhilosophy
